import { render, staticRenderFns } from "./split-vertical-box.vue?vue&type=template&id=5b410e0e&"
import script from "./split-vertical-box.vue?vue&type=script&lang=js&"
export * from "./split-vertical-box.vue?vue&type=script&lang=js&"
import style0 from "./split-vertical-box.vue?vue&type=style&index=0&id=5b410e0e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports